import { gql } from '@apollo/client';

export const UPDATE_ATTACHMENT = gql`
  mutation updateAttachment($input: UpdateAttachmentInput!) {
    updateAttachment(input: $input) {
      clientMutationId
      errors
      attachmentUuid
      attachment {
        attachmentType {
          id
          name
        }
        confidential
        dataFileName
        dataUrl
        dataUrlWrapper
        description
        employee {
          id
        }
        id
        incident {
          id
        }
        lastUpdated
        ownerName
        unencryptedDataUrlWrapper
      }
    }
  }
`